import { useEffect, useRef } from 'react';
import { VisuallyHidden } from './VisuallyHidden';

export function HiddenFocus({ children }: { children: string }) {
	const ref = useRef<HTMLSpanElement>(null);
	useEffect(() => ref.current?.focus(), [ref.current]);
	return (
		<VisuallyHidden>
			<span ref={ref} tabIndex={-1}>
				{children}
			</span>
		</VisuallyHidden>
	);
}
